<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>배너01 등록</div>
            </strong>
          </div>
          <div class="table-responsive">
            <table class="table b-table table-striped">
              <tbody class="">
              <!-- 활성화 start -->
              <tr class="form_tr" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">활성화</label>
                </td>

                <td class="" style="vertical-align:middle">
                  <c-switch type="text" variant="primary" v-model="queryParams.active_yn" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                </td>
              </tr>
              <!-- 활성화 end -->

              <!-- 슬롯번호 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">슬롯번호</label>
                </td>

                <td class="">
                  <multiselect
                    v-model="mainSlotData"
                    :options="mainSlotNumberOptions"
                    :custom-label="mainSlotNumLabel"
                    :disabled="multiselectStatus"
                    placeholder="키비쥬얼 슬롯 번호"
                    label="num" style="width:570px" track-by="num"/>
                </td>
              </tr>
              <!-- 슬롯번호 end -->

              <!-- 제목 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">제목</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="10">
                      <b-form-input id="basicText" name="postsubject" type="text"
                                    v-model="queryParams.postsubject"
                                    v-validate="'required'"
                                    :class="{'is-invalid': errors.has('postsubject')}" placeholder="최대 15자까지 입력가능합니다."/>
                      <span v-show="errors.has('postsubject')" :class="{error: errors.has('postsubject')}">제목은 필수 항목 입니다.</span>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <!-- 제목 end -->

              <!-- 활성기간 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">활성기간 설정</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="2">
                      <b-form-input type="text" name="daterange"/>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <!-- 활성기간 end -->

              <!-- PC 이미지 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" rowspan="2" style="background-color:#f1f1f1; vertical-align:middle">
                  <label class="col-form-label">이미지 업로드<br/>(730 x 410)</label>
                </td>
                <td class="" colspan="4">
                  <b-row class="pt-sm-12">
                    <b-col sm="12">
                      <div :class="PCimgFileCheck ? 'imgfile' : 'imgfilenone'">
                        <input id="pc_file" class="form-control-file" type="file" ref="pc_file" accept=".jpg, .jpeg, .png" style="padding:5px"
                               v-on:change="handleFileUpload('MAIN_FILE','PC')"/>
                      </div>
                      <div>
                        <b class="pc_img imgnone" style="display:inline-block; background:#ea0000; padding:7px 10px; margin:0 0 0 10px; border-radius:5px; color:#ffffff; font-size:14px; float:left">이미지는 필수로 등록해주세요.</b>
                      </div>
                    </b-col>
                  </b-row>
                </td>
              </tr>

              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td class="" colspan="4">
                  <b-row class="pt-sm-12">
                    <b-col sm="12">
                      <span style="color:#ea0000; font-weight:bold; font-size:12px; display:inline-block" v-show="queryParams.listThumbnailFile.PC.length != 0">
                        * 이미지 확인용 입니다. 현재 업로드된 사이즈는 {{queryParams.img_width}} x {{queryParams.img_height}} 입니다.
                      </span><br>
                      <div :class="PCimgFileCheck ? 'imgdiv' : 'imgdivnone'">
                        <div v-show="queryParams.listThumbnailFile.PC.length == 0" style="display: table-cell; vertical-align: middle" id="pc_imgcreat">
                          <div style="width:300px; height:25px; margin:0 auto; font-weight:bold">
                            <i class="icon-close font-5xl" style="float:left; margin-right:10px; color:#f27474"></i>
                            <label class="col-form-label" style="float:left; padding:0; margin:0; font-size:20px; ling-height:35px">이미지를 업로드 해주세요.</label>
                          </div>
                        </div>
                        <img id="pc_imgdata" alt="img"
                             v-show="queryParams.listThumbnailFile.PC.length != 0"
                             :src="item.file_url"
                             v-for="(item, idx) in queryParams.listThumbnailFile.PC">
                      </div>
                      <b-button id="pc_imgdel" class="mx-1 delete_button_on" size="sm" variant="danger" style="float:right"
                                v-on:click="imgFileDelete('PC')"
                                v-show="queryParams.listThumbnailFile.PC.length != 0">
                        <h5 style="margin-bottom:0px">
                          <i class="fa fa-remove"></i> 제거
                        </h5>
                      </b-button>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <!-- PC 이미지 end -->

              <!-- MO 이미지 start -->
              <!--
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" rowspan="2" style="background-color:#f1f1f1; vertical-align:middle">
                  <label class="col-form-label">MO 이미지 업로드<br/>(nnn x xxx)</label>
                </td>
                <td class="" colspan="4">
                  <b-row class="pt-sm-12">
                    <b-col sm="12">
                      <div :class="MOimgFileCheck ? 'imgfile' : 'imgfilenone'">
                        <input type="file" class="form-control-file"
                               id="mo_file"
                               ref="mo_file" accept=".jpg, .jpeg, .png"
                               style="padding:5px"
                               v-on:change="handleFileUpload('MAIN_FILE','MO')"/>
                      </div>
                      <div>
                        <b class="mo_img imgnone" style="display:inline-block; background:#ea0000; padding:7px 10px; margin:0 0 0 10px; border-radius:5px; color:#ffffff; font-size:14px; float:left">이미지는 필수로 등록해주세요.</b>
                      </div>
                    </b-col>
                  </b-row>
                </td>
              </tr>

              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td class="" colspan="4">
                  <b-row class="pt-sm-12">
                    <b-col sm="12">
                      <span style="color:#ea0000; font-weight:bold; font-size:12px; display:inline-block" v-show="queryParams.listThumbnailFile.MO.length != 0">
                        * 이미지 확인용 입니다. 현재 업로드된 사이즈는 {{queryParams.mo_img_width}} x {{queryParams.mo_img_height}} 입니다.
                      </span><br>
                      <div :class="MOimgFileCheck ? 'imgdiv' : 'imgdivnone'">
                        <div id="mo_imgcreat" style="display: table-cell; vertical-align: middle" v-show="queryParams.listThumbnailFile.MO.length == 0">
                          <div style="width:300px; height:25px; margin:0 auto; font-weight:bold">
                            <i class="icon-close font-5xl" style="float:left; margin-right:10px; color:#f27474"></i>
                            <label class="col-form-label" style="float:left; padding:0; margin:0; font-size:20px; ling-height:35px">이미지를 업로드 해주세요.</label>
                          </div>
                        </div>
                        <img id="mo_imgdata" alt="img"
                             :src="item.file_url"
                             v-for="(item, idx) in queryParams.listThumbnailFile.MO"
                             v-show="queryParams.listThumbnailFile.MO.length != 0">
                      </div>
                      <b-button id="mo_imgdel" class="mx-1 delete_button_on" size="sm" variant="danger" v-on:click="imgFileDelete('MO')"  v-show="queryParams.listThumbnailFile.MO.length != 0" style="float:right">
                        <h5 style="margin-bottom:0px">
                          <i class="fa fa-remove"></i> 제거
                        </h5>
                      </b-button>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              -->
              <!-- MO 이미지 end -->

              <!-- 타겟 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">타겟</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="2">
                      <label class="col-form-label">
                        <b-form-radio-group v-model="queryParams.target_yn">
                          <b-form-radio value="Y">현재창</b-form-radio>
                          <b-form-radio value="N">새창</b-form-radio>
                        </b-form-radio-group>
                      </label>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <!-- 타겟 end -->

              <!-- 랜딩 URL start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">랜딩 URL</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="10">
                      <b-form-input id="basicText" name="landingurl" type="text" v-model="queryParams.landing_url" v-validate="'required'" :class="{'is-invalid': errors.has('landingurl')}"/>
                      <span v-show="errors.has('landingurl')" :class="{error: errors.has('landingurl')}">
                                  랜딩 URL은 필수 항목 입니다.
                                </span>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <!-- 랜딩 URL end -->

              <!-- 설명 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">설명</label>
                </td>
                <td class="" colspan="4">
                  <textarea id="basicText" rows="10" cols="200" style="border:1px solid #c2cfd6" v-model="queryParams.explanation"/>
                </td>
              </tr>
              <!-- 설명 end -->
              </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">&nbsp;</b-col>
          <b-col sm="3" lg="4">&nbsp;</b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4"></b-col>
                <b-col md="4">
                  <b-button variant="warning" v-on:click="saveMainBanner()" v-if="formtype == 'update'" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #c5940d; font-size:15px">
                    <h5 style="margin-bottom:0px">
                      <i class="fa fa-edit"></i> 수정
                    </h5>
                  </b-button>
                  <b-button variant="success" v-on:click="saveMainBanner()" v-if="formtype == 'insert'" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px">
                    <h5 style="margin-bottom:0px">
                      <i class="fa fa-hand-o-up"></i> 등록
                    </h5>
                  </b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/site/mainmanagement'">
                    <h5 style="margin-bottom:0px">
                      <i class="fa fa-list-ul"></i> 목록
                    </h5>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue';
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import cSwitch from '../../../../../components/Switch'
const moment = require("moment")
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, {
  locale: 'ko'
})

export default {
  name: 'Banner01ManagementForm',
  components: {
    Multiselect,
    cSwitch
  },
  data() {
    return {
      bannercode: '',
      PCimgFileCheck: true,
      MOimgFileCheck: true,
      newFlag: 'new',
      mainSlotNumberOptions: [],   // 슬롯 넘버 선택시 옵션
      mainSlotData: '',
      formtype: '',               //insert : 등록, update : 수정
      multiselectStatus: false, //multiselect 활성화
      queryParams: {
        postsubject: '',
        banner_type: 'banner01',
        contents_type: 'img',
        img_url: '',
        img_width: 0,
        img_height: 0,
        landing_url: '',
        active_yn: '',
        slot_number: 1,
        explanation: '',
        listThumbnailFile: {'PC': [], 'MO': []},
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(3, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
        mo_img_url: '',
        mo_img_width: 0,
        mo_img_height: 0,
        sub_title: '',        //분류문구
        tag: '',              //태그
        target_yn: 'Y',       //타겟설정 Y: 현재 N: 새창
        contents_html: '',    //내용
        slotNumberDatas: [],  //전체 슬롯 데이터
        targetSlotNumberData: {} //선택한 슬롯 데이터
      },
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      }
    }
  },
  watch: {
    'queryParams.active_yn': function () {
      // 배너 상태가 활성화고 수정 페이지면 멀티셀렉트 활성화
      if (this.queryParams.active_yn === 'Y' && this.formtype === 'update') {
        this.multiselectStatus = false
      } else if (this.queryParams.active_yn === 'N' && this.formtype === 'update') {
        this.multiselectStatus = true
        // multiselect에 자기 코드로 선택
        this.mainSlotData = this.mainSlotNumberOptions.find(option => option.code === this.bannercode)
      }
    }
  },
  mounted: function() {
    var self = this
    self.formtype = self.$route.query.status
    self.$session.set('page_banner_type', self.queryParams.banner_type)
    if (self.formtype === 'update') {
      self.bannercode = self.$session.get('bannercode')
      self.getMainManagementData(self.bannercode)
    } else {
      var items = {code: 'newbanner', name: '현재 적용중', num: 1}
      self.mainSlotNumberOptions.push(items)
      self.mainSlotData = self.mainSlotNumberOptions
      self.multiselectStatus = true
    }

    // multiselect 생성 이후 값 조절을 위함
    setTimeout(function() {
      self.getSlotNumberOptions();
    }, 100);

    /*
    this.$nextTick(function () {
      self.getSlotNumberOptions();
    })
     */

    $(function () {
      $(".imgnone").hide();
      $('input[name="daterange"]').daterangepicker({
        opens: 'left',
        "locale": self.calendarLocale,
        "endDate": self.queryParams.end_date,
        "startDate": self.queryParams.start_date
      }, function(start, end, label) {
        self.queryParams.start_date = start.format('YYYY-MM-DD');
        self.queryParams.end_date = end.format('YYYY-MM-DD');
      });
    });
  },
  methods: {
    mainSlotNumLabel ({ name, num }) {
      return `${num} - ${name}`;
    },

    // 활성화된 1~5까지의 슬롯 번호를 가져옴
    getSlotNumberOptions () {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);
      self.$http.post('/api/select/slotNumberOptions?access_token=' + token, data, null)
        .then((result) => {
          var slotNumberDatas = [];
          slotNumberDatas = result.data;

          slotNumberDatas.forEach(function (el, idx, arr){
            var setSlotNum = el.slot_number;

            //신규등록일 경우 최초 newbanner가 들어가기 때문에 SlotNum + 1을 해준다.
            if(self.formtype != 'update'){
              setSlotNum = setSlotNum + 1;
            }

            //mainSlotNumberOptions 배열에 차례대로 push
            var items = { code: el.banner_code, name: el.postsubject, num: setSlotNum };
            self.mainSlotNumberOptions.push(items);

            // 오름차순 정렬
            self.mainSlotNumberOptions.sort(function(a, b) {
              return a.num < b.num ? -1 : a.num > b.num ? 1 : 0;
            });
          });

          // multiselect 초기값 세팅
          self.mainSlotNumberOptions.some(function (el, idx) {
            if (self.formtype === 'insert' && idx === 0) {
              self.mainSlotData = el;
              return true;
            }
            if (el.num === self.queryParams.slot_number) {
              self.mainSlotData = el;
              return true;
            }
            return false;
          });

          if (self.mainSlotNumberOptions.length < 5 && self.queryParams.active_yn == 'N'){
            var items = {code: self.bannercode, name: '마지막 슬롯', num: self.mainSlotNumberOptions.length +1 };
            self.mainSlotNumberOptions.push(items);
            self.mainSlotData = items;
          }
        })
    },


    // 배너 데이터 조회
    getMainManagementData(bannercode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/KeyVisualBannerData?access_token=' + token + '&bannercode=' + bannercode)
        .then((result) => {
          self.queryParams = result.data;
          self.queryParams.listThumbnailFile = {'PC':[],'MO':[]};
          var pc_fileArr = {
            file_url: self.queryParams.img_url,
            file_width: self.queryParams.img_width,
            file_height: self.queryParams.img_height
          };
          var mo_fileArr = {
            file_url: self.queryParams.mo_img_url,
            file_width: self.queryParams.mo_img_width,
            file_height: self.queryParams.mo_img_height
          }
          self.queryParams.listThumbnailFile.PC.push(pc_fileArr);
          self.queryParams.listThumbnailFile.MO.push(mo_fileArr);
        })
    },

    // 배너 저장 및 수정
    saveMainBanner() {
      var self = this;

      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');

          if(self.queryParams.listThumbnailFile.PC.length == 0){
            $(".pc_img").show();
            self.PCimgFileCheck = false;
            window.scrollTo(0,0);
            return false;
          }

          /*
          if(self.queryParams.listThumbnailFile.MO.length == 0){
            $(".mo_img").show();
            self.MOimgFileCheck = false;
            window.scrollTo(0,0);
            return false;
          }
          */

          self.queryParams.slotNumberDatas = self.mainSlotNumberOptions;
          self.queryParams.targetSlotNumberData = self.mainSlotData;

          self.queryParams.listThumbnailFile.PC.forEach(function (el, idx, arr){
            self.queryParams.img_url = el.file_url;
            self.queryParams.img_width = el.file_width;
            self.queryParams.img_height = el.file_height;
          });

          self.queryParams.listThumbnailFile.MO.forEach(function (el, idx, arr){
            self.queryParams.mo_img_url = el.file_url;
            self.queryParams.mo_img_width = el.file_width;
            self.queryParams.mo_img_height = el.file_height;
          });

          //배너 활성화 최소 조건
          if (self.mainSlotNumberOptions.length == 1 && self.queryParams.active_yn=='N'){
            swal.fire('배너는 최소 1개 이상<br/> 게재되어야 합니다!', '', 'error');
            return;
          }

          /*
          else if (self.mainSlotNumberOptions.length == 5 && self.queryParams.active_yn=='Y'){
            swal.fire('배너 사용은 최대 5개까지 입니다.', '', 'error');
            return;
          }
          */

          console.log('slotlen >>>', self.mainSlotNumberOptions.length);
          console.log('active_yn >>>', self.queryParams.active_yn);
          console.log('queryParams >>>', self.queryParams);
          console.log('mainSlotData >>>', self.mainSlotData);

          if (self.queryParams.active_yn=='Y' && self.mainSlotData == null){
            swal.fire('변경하실 슬롯을 선택해주세요.', '', 'error');
            return;
          }

          //모든 유효성 통과
          //비활성화라면 slot_number 99 고정
          if (this.queryParams.active_yn=='N'){
            this.queryParams.slot_number = 99;
          }

          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('objs', param);
          if(self.formtype == 'insert'){
            self.$http.post('/api/insert/mainBanner?access_token='+token, data, null)
              .then((result) => {

                swal.fire({
                  type: 'success',
                  title: '배너가 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                  window.location = "#/site/mainmanagement";
                });

              })
          }else if(self.formtype == 'update'){

            self.$http.post('/api/update/mainBanner?access_token='+token, data, null)
              .then((result) => {

                swal.fire({
                  type: 'success',
                  title: '배너가 수정되었습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                  window.location = "#/site/mainmanagement";
                });
              })

          }
        } else {
          window.scrollTo(0,0);
        }
      })
    },

    // ### 단일 파일업로드 ###
    handleFileUpload(fileType,uploadTpye){
      var self = this;
      var token = sessionStorage.getItem("myToken");
      let reportType = '';

      if (uploadTpye=='PC'){
        reportType = 'mainbanner/banner01/pc';
        self.file = self.$refs.pc_file.files[0];
        self.queryParams.listThumbnailFile.PC = [];
      } else {
        reportType = 'mainbanner/banner01/mo';
        self.file = self.$refs.mo_file.files[0];
        self.queryParams.listThumbnailFile.MO = [];
      }

      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('reportType', reportType);
      formData.append('fileSubPath', 'img');  //fileSubPath를 img로 세팅해야 width, height 값을 받아옴

      self.$http.post('/ftpserver/dropAndSingleFileUpload?access_token='+token, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((result) => {
          result.data.file_type_code = fileType;
          if (uploadTpye == 'PC'){

            self.queryParams.listThumbnailFile.PC.push(result.data);
            self.queryParams.listThumbnailFile.PC.forEach(function (el, idx, arr){
              self.queryParams.img_url = el.file_url;
              self.queryParams.img_width = el.file_width;
              self.queryParams.img_height = el.file_height;
            });

            $(".pc_img").hide();
            $("#pc_imgcreat").hide();
            $("#pc_imgdata").show();
            $("#pc_imgdata").attr("src" ,self.queryParams.img_url);
            $("#pc_imgdel").show();
            self.PCimgFileCheck = true;
          } else {

            self.queryParams.listThumbnailFile.MO.push(result.data);
            self.queryParams.listThumbnailFile.MO.forEach(function (el, idx, arr){
              self.queryParams.mo_img_url = el.file_url;
              self.queryParams.mo_img_width = el.file_width;
              self.queryParams.mo_img_height = el.file_height;
            });

            $(".mo_img").hide();
            $("#mo_imgcreat").hide();
            $("#mo_imgdata").show();
            $("#mo_imgdata").attr("src" ,self.queryParams.mo_img_url);
            $("#mo_imgdel").show();
            self.MOimgFileCheck = true;
          }
        })
    },
    imgFileDelete(imgType){
      var self = this;
      if (imgType == 'PC'){
        self.queryParams.listThumbnailFile.PC = [];
        $("#pc_imgcreat").show();
        $("#pc_imgcreat").css("display", "table-cell");
        $("#pc_imgdata").hide();
        $("#pc_imgdata").attr("src", "");
        $("#pc_imgdel").hide();
        $("#pc_file").val('');
      } else {
        self.queryParams.listThumbnailFile.MO = [];
        $("#mo_imgcreat").show();
        $("#mo_imgcreat").css("display", "table-cell");
        $("#mo_imgdata").hide();
        $("#mo_imgdata").attr("src", "");
        $("#mo_imgdel").hide();
        $("#mo_file").val('');
      }
    },
  }
}

$(document).ready(function(){
  var xOffset = 50;
  var yOffset = 10;
  $(document).on("mouseover",".imgview",function(e){ //마우스 오버시
    $("body").append("<p id='preview'><img src='"+ $(this).attr("data") +"' /></p>"); //보여줄 이미지를 선언
    $("#preview")
      .css("position","absolute")
      .css("top",(e.pageY - xOffset) + "px")
      .css("left",(e.pageX + yOffset) + "px")
      .fadeIn("fast"); //미리보기 화면 설정 셋팅
  });
  $(document).on("mousemove",".imgview",function(e){ //마우스 이동시
    $("#preview")
      .css("top",(e.pageY - xOffset) + "px")
      .css("left",(e.pageX + yOffset) + "px");
  });
  $(document).on("mouseout",".imgview",function(){ //마우스 아웃시
    $("#preview").remove();
  });
});
</script>



<style lang="css" scoped>
.delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
.delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
.clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
.clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}

.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
  padding:20px
}

.normal {
  background-color: grey;
}

.dragArea{
  min-height: 10px;
}

.sortable-chosen {
  opacity: 0.7;
  background-color:#dcdcdc;
}

.sortable-ghost {
  background-color:#dcdcdc;
}
.handle {
  padding: 5px;
  margin-right: 10px;
  border: solid #000 1px;
  cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}

.imgdiv {
  margin:0 auto;
  display: inline-table;
  border:1px solid #a3b6c0;
  min-width:500px;
  min-height:100px;
}

.imgdivnone {
  margin:0 auto;
  display: inline-table;
  border:1px solid #ea0000;
  min-width:500px;
  min-height:100px;
}

img {
  display: block;
  max-width:1350px;
  max-height:850px;
  width: auto;
  height: auto;
}

.imgfile {
  border:1px solid #c2cfd6; border-radius:4px; width:70%; float:left
}

.imgfilenone {
  border:1px solid #ea0000; border-radius:4px; width:70%; float:left
}

.imgnone {
  padding: 12px 24px;
  background-color: hsl(222, 100%, 95%);
  color: hsl(243, 80%, 62%);
  border-radius: 6px;
  box-shadow: 0 0 0 0 rgba(200, 25, 25, 0.7);
  animation: pulse 1.75s infinite cubic-bezier(0.66, 0, 0, 1);
}

@keyframes pulse {
  to {
    box-shadow: 0 0 0 30px rgba(200, 25, 25, 0);
  }
}
</style>
<style src="../../../../../../node_modules/daterangepicker/daterangepicker.css"></style>
<style src="../../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/site/main/component/banner01/Banner01ManagementForm.vue